
import { Link, useParams } from "react-router-dom";
import { SidebarInset } from "@/components/ui/sidebar";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { ChevronRight } from "lucide-react";
import { useFundData } from "@/hooks/useFundData";
import { PageContainer } from "@/components/ui/PageContainer";

interface FundProfileLayoutProps {
  children: React.ReactNode;
}

export const FundProfileLayout = ({ children }: FundProfileLayoutProps) => {
  const { fundId } = useParams();
  const { data: fund } = useFundData(fundId);
  
  return (
    <div className="flex-1">
      <header className="flex h-14 shrink-0 items-center gap-2 border-b px-4 sticky top-0 bg-background z-10">
        <SidebarTrigger className="-ml-2" />
        <Separator orientation="vertical" className="h-6" />
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">Dashboard</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator>
              <ChevronRight className="h-4 w-4" />
            </BreadcrumbSeparator>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/explore">Discover</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator>
              <ChevronRight className="h-4 w-4" />
            </BreadcrumbSeparator>
            <BreadcrumbItem>
              <BreadcrumbPage>{fund?.fund_name || 'Fund Details'}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </header>
      <SidebarInset>
        <PageContainer maxWidthClassName="max-w-[960px]" className="overflow-x-hidden">
          <div className="space-y-8 min-w-0">
            {children}
          </div>
        </PageContainer>
      </SidebarInset>
    </div>
  );
};
